import React from 'react';
import TextField from '@mui/material/TextField';

export default function TextFieldCP (props: any) {

  return <TextField size="small" {...props} />;
}